import React, { useContext, useEffect, useState } from "react";
import { Request } from "../../api/auth/Logout.api";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useHistory } from "react-router";
import PrivateTopBar from "../../components/PrivateTopBar";
import {
  AuthContextDispatchContext,
  AuthContext,
} from "../../context/auth/AuthContext";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  connectionLineStatusResetState,
  initConnectionLineStatus,
} from "../../store/eklok-line-status.store";
import { useMediaQuery } from "../../hooks/mediaQuery";

const ToolbarContainer = ({ onMobileNavOpen }) => {
  const history = useHistory();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { deleteToken } = useContext(AuthContextDispatchContext);
  const { token } = useContext(AuthContext);
  const isMobile = useMediaQuery();
  const dispatch = useDispatch();
  const { eklok, processLine } = useSelector((state) => {
    return state.eklokLineStatus;
  });

  const onSubmitLogout = () => {
    setError(null);
    setLoading(true);
    if (eklok && isMobile) {
      dispatch(
        initConnectionLineStatus({
          token: token,
          body: { eklok: eklok, line_status: false, processLine: "DO_LOGOUT" },
        }),
      );
    } else {
      Request.logout(token)
        .then(() => onSuccess())
        .catch((error) => onFailure(error));
    }
  };

  const onSuccess = () => {
    setLoading(false);
    deleteToken();
    dispatch(connectionLineStatusResetState());
    history.push("/");
  };

  const onFailure = (error) => {
    setError(error);
    setLoading(false);
  };

  useEffect(() => {
    if (processLine === "DO_LOGOUT" && isMobile) {
      Request.logout(token)
        .then(() => onSuccess())
        .catch((error) => onFailure(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processLine, isMobile]);

  return (
    <Fragment>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      <PrivateTopBar
        onMobileNavOpen={onMobileNavOpen}
        onLogout={() => onSubmitLogout()}
      />
    </Fragment>
  );
};

export default ToolbarContainer;
